<template>
  <div class="data">
    <div class="data-header">
        <banner></banner>
    </div>
      <v-btn-toggle
          v-model="display_select"
          mandatory
          v-if="user"
      >
          <v-btn value="scan" to="/my-data/scan" v-if="!hideScan">
              SCAN
          </v-btn>
          <v-btn value="points" to="/my-data/points">
              POINTS
          </v-btn>
          <v-btn value="photos" to="/my-data/photos">
              PHOTOS
          </v-btn>
      </v-btn-toggle>

      <points-display v-if="display_select === 'points'" class="data-overlay"></points-display>

      <evolt-display v-if="display_select === 'scan'" class="data-overlay"></evolt-display>

      <photo-display v-if="display_select === 'photos'" class="data-overlay"></photo-display>



  </div>
</template>

<script>
  //import LineChart from '../components/LineChart.js'
  // import BarChart from '../components/BarChart.js'
  import EvoltDisplay from '../components/EvoltDisplay';

  import { mapState } from 'vuex'
  import PointsDisplay from '../components/PointsDisplay'
  import PhotoDisplay from "@/components/PhotoDisplay";
  import Banner from "@/components/Banner";

  export default {
      mounted() {
          this.display_select = this.$route.params.section ? this.$route.params.section : 'scan'
      },
    components: {
        Banner,
        PhotoDisplay,
        PointsDisplay,
        EvoltDisplay,
    },
    computed: {
      ...mapState({
        challenge: state => state.challenge.challenge,
          hideScan: state => state.auth.user.hideScan,
          user: state => state.auth.user
      })
    },
    data () {
      return {
        data: [],
          display_select: null
      }
    },
    beforeCreate() {
      this.$nextTick().then(() => document.body.classList.add('has-refresh'))
    },
    beforeDestroy() {
      this.$nextTick().then(() => document.body.classList.remove('has-refresh'))
    }
  }
</script>

<style scoped lang="scss">

    .data-value {
        padding: 0 10px;
        width: 100%;
        display: inline-block;
        text-align: center;
        color: #24ADBB;
        font-weight: bold;

    }
    .before-after-btns {
        button {
            width: 50%;
        }
    }
  .data {
      .v-btn-toggle {
          display: flex;
          .v-btn {
              flex-basis: 0;
              flex-grow: 1;
          }
      }
      padding-bottom: 30px;
    .v-alert {
      display: flex !important;
    }
    width: 100%;
    .image-container {
      margin: 10px 30px !important;
    }
    .chart-type {
      .v-btn-toggle {
        width: 100%;
        .v-btn {
          opacity: 1 !important;
          &.primary {
            color: #000000;
          }
          &--active {
            color: white !important;
            background: #2FADBA;
          }
        }
      }
    }
  }

    .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        color: #24adbb;
        padding-top: 20px;
        padding-bottom: 20px;
        font-size: 18px;
        font-weight: 500;
    }

</style>
